import React from "react";
const KC={twap:{color:"#06b6d4",icon:"📊"},top_trader:{color:"#a855f7",icon:"🐋"},price:{color:"#22c55e",icon:"💰"},default:{color:"#6b7280",icon:"🔔"}};
const LC={urgent:"#ef4444",warn:"#f59e0b",watch:"#06b6d4",skew:"#a855f7",above:"#22c55e",below:"#ef4444"};
export default function AlertLog({ logs }) {
  if (!logs?.length) return <p style={{color:"#4b5563",fontSize:12}}>알림 이력 없음</p>;
  return (
    <div style={{display:"flex",flexDirection:"column",gap:7,maxHeight:300,overflowY:"auto"}}>
      {logs.map((log,i)=>{
        const ks=KC[log.kind]||KC.default; const lc=LC[log.level]||"#6b7280";
        return (
          <div key={i} style={{padding:"8px 12px",borderRadius:8,background:"#181c24",
            border:`1px solid ${lc}33`,display:"flex",gap:10,alignItems:"flex-start"}}>
            <span style={{fontSize:15,flexShrink:0}}>{ks.icon}</span>
            <div style={{flex:1}}>
              <div style={{display:"flex",justifyContent:"space-between",marginBottom:2}}>
                <span style={{fontSize:12,fontWeight:700,color:lc}}>{log.level?.toUpperCase()}</span>
                <span style={{fontSize:11,color:"#4b5563"}}>{log.ts}</span>
              </div>
              <p style={{fontSize:12,color:"#9ca3af"}}>{log.detail||log.msg}</p>
            </div>
          </div>
        );
      })}
    </div>
  );
}
